module.exports = __webpack_public_path__ + "lydia.jpg?2344add2b23cb7456359254ff2dc0971";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/customers/lydia.jpg
// module id = 6
// module chunks = 0